<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="breakpoints.lgAndUp ? '30%' : '65%'"
    top="30vh"
    :before-close="handleClose"
    custom-class="custom-scrollable"
  >
    <div class="font-normal mb-6 text-root-2">
      <div
        style="word-break: normal"
        class="font-normal text-root-4 flex justify-center text-center my-4 py-3"
      >
        Are you sure you want to delete <br v-if="breakpoints.lgAndUp" />
        this beneficiary address?
      </div>
      <div
        class="md:flex-row flex-col flex text-white justify-around items-center w-full"
      >
        <div
          @click="handleClose"
          class="bg-root cursor-pointer font-semibold hover:opacity-80 flex mb-3 md:mb-0 text-primary items-center justify-center border border-primary rounded-full md:px-10 py-3"
        >
          Not sure
        </div>
        <div
          @click="verifyDeleteWalletAddress"
          class="bg-primary cursor-pointer hover:opacity-80 font-semibold flex items-center justify-center rounded-full md:px-14 py-3"
        >
          Sure
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breakpoints
    }
  },
  methods: {
    verifyDeleteWalletAddress () {
      this.$emit('closeDialog')
      this.$emit('verifyDeleteWalletAddres')
    },
    handleClose () {
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 30px;
  padding: 0px 20px 10px 10px;
}
>>> .el-dialog__body {
  padding: 0px 20px;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  padding: 25px;
  opacity: 0.9;
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
</style>
